import { render, staticRenderFns } from "./ModalWithMap.vue?vue&type=template&id=18912bb6&lang=pug"
import script from "./ModalWithMap.vue?vue&type=script&lang=js"
export * from "./ModalWithMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports